import { gql, useQuery } from "@apollo/client";

export const BackofficeWorkers = gql`
	query BackofficeWorkers($term: String, $limit: Int, $offSet: Float) {
		backofficeWorkers(
			paginationInfo: { term: $term, limit: $limit, offSet: $offSet }
		) {
			data {
				_id
				email
				name
				phoneNumber
				addressInfo {
					Address
					postalCode
				}
				localidade
				nif
				avatar
				createdAt
			}
			paginantionInfo {
				numberDocuments
				currentSkip
			}
		}
	}
`;
